import React from "react";
import { scrollToApply } from "../utils/scroll";
import { arrowClass, CTA_MICROCOPY, primaryButtonClass } from "../utils/buttonStyles";
import { track, type CtaSource } from "../utils/tracking";
type CTAButtonProps = {
  source: CtaSource;
  label?: string;
  microcopy?: string | null;
  className?: string;
};
export function CTAButton({
  source,
  label = "QUIERO MI DIAGNÓSTICO GRATIS",
  microcopy = CTA_MICROCOPY,
  className = ""
}: CTAButtonProps) {
  const onClick = () => {
    track("CTAClick", {
      source
    }, {
      custom: true
    });
    scrollToApply();
  };
  return <div className={`flex w-full flex-col items-start gap-3 sm:w-auto ${className}`} data-id="element-134" data-mp="33owdl2y8ejf8">
      <button type="button" onClick={onClick} className={`${primaryButtonClass} w-full sm:w-auto`} data-id="element-135" data-mp="33r0i9n3yfmgk">
        {label}
        <span className={arrowClass} aria-hidden="true" data-id="element-136" data-mp="3cpkq1t7z8bq0">
          →
        </span>
      </button>
      {microcopy && <p className="text-[14px] leading-snug text-muted" data-id="element-137" data-mp="38osfmwndc0s5">{microcopy}</p>}
    </div>;
}